import _extends from 'babel-runtime/helpers/extends';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import DEFAULTS from './constants';
import { isFunction } from './typeChecks';
import { bindResources, mergeConfig } from './util';

var Router = function () {
    function Router(routes, config) {
        _classCallCheck(this, Router);

        // Set config
        this._customConfig = config;

        // set parent to null
        this._parent = null;

        var defaultRoutes = this.defaultRoutes || this.constructor.defaultRoutes;

        this._childKeys = [];

        if (defaultRoutes) {
            bindResources(defaultRoutes, this);
        }

        // Set routes
        if (routes) {
            bindResources(routes, this);
        }
    }

    _createClass(Router, [{
        key: 'getHeaders',
        value: function getHeaders() {
            var headers = _extends({}, this.parent ? this.parent.getHeaders() : {}, (isFunction(this.config().headers) ? this.config().headers() : this.config().headers) || {});

            return headers;
        }
    }, {
        key: 'getCookies',
        value: function getCookies() {
            return _extends({}, this.parent ? this.parent.getCookies() : {}, (isFunction(this.config().cookies) ? this.config().cookies() : this.config().cookies) || {});
        }
    }, {
        key: '_setParent',
        value: function _setParent(parent) {
            this._parent = parent;
        }
    }, {
        key: 'config',
        value: function config() {
            if (!this._config) {
                this._config = mergeConfig(this._parent ? this._parent.config() : DEFAULTS, this.defaultConfig || this.constructor.defaultConfig || null, this._customConfig);
            }

            return this._config;
        }
    }, {
        key: 'setConfig',
        value: function setConfig(config) {
            // Update _customConfig
            this._customConfig = _extends({}, this._customConfig, config || {});

            // Reset _config so it is recreated in the next call to .config
            this.clearConfigCache();
        }
    }, {
        key: 'clearConfigCache',
        value: function clearConfigCache() {
            var _this = this;

            this._config = null;

            this._childKeys.forEach(function (key) {
                _this[key].clearConfigCache();
            });
        }
    }, {
        key: 'parent',
        get: function get() {
            return this._parent;
        }
    }, {
        key: 'isBound',
        get: function get() {
            return !!this._parent || !!this._config;
        }
    }]);

    return Router;
}();

export default Router;


//////////////////
// WEBPACK FOOTER
// ../~/tg-resources/es/router.js
// module id = 842
// module chunks = 0